import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

const STORAGE_KEY = 'c8_user_login_recorded';

@Injectable({ providedIn: 'root' })
export class UserLoginService {
  private readonly apiUrl = `${environment.PROTOCOL}://${environment.API_URL}:${environment.API_PORT}/api/v1/c8`;

  constructor(private http: HttpClient) {}

  recordLoginIfNeeded(): void {
    if (typeof sessionStorage === 'undefined' || sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }
    const body = { lastLoggedIn: new Date().toISOString() };
    this.http.post(`${this.apiUrl}/user/record-login`, body).subscribe({
      next: () => sessionStorage.setItem(STORAGE_KEY, '1'),
      error: () => {}
    });
  }

  clearTracking(): void {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
}
